/** @jsx jsx */
import { h, FunctionalComponent } from 'preact'
import { jsx } from '@emotion/core'
import { StylesObject } from '../../../types/styles'

interface DividerProps {
    styles: StylesObject
}

export const Divider: FunctionalComponent<DividerProps> = ({ styles }) => {
    return <div css={styles.divider}></div>
}
